var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsCloseSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a7aa",
    id: "svg_1",
    d: "m443.6,387.1l-131.2,-131.7l131.5,-130c5.4,-5.4 5.4,-14.2 0,-19.6l-37.4,-37.6c-2.6,-2.6 -6.1,-4 -9.8,-4c-3.7,0 -7.2,1.5 -9.8,4l-130.9,129.6l-131.1,-129.5c-2.6,-2.6 -6.1,-4 -9.8,-4c-3.7,0 -7.2,1.5 -9.8,4l-37.3,37.6c-5.4,5.4 -5.4,14.2 0,19.6l131.5,130l-131.1,131.6c-2.6,2.6 -4.1,6.1 -4.1,9.8c0,3.7 1.4,7.2 4.1,9.8l37.4,37.6c2.7,2.7 6.2,4.1 9.8,4.1c3.5,0 7.1,-1.3 9.8,-4.1l130.6,-131.2l130.7,131.1c2.7,2.7 6.2,4.1 9.8,4.1c3.5,0 7.1,-1.3 9.8,-4.1l37.4,-37.6c2.6,-2.6 4.1,-6.1 4.1,-9.8c-0.1,-3.6 -1.6,-7.1 -4.2,-9.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCloseSmall);
export default __webpack_public_path__ + "static/media/iconsCloseSmall.4dfbb7590f48481cfa56a720ddc9ed45.svg";
export { ForwardRef as ReactComponent };